<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('modalidadenvio')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            <span align="justify">
              Información del Estado de Cuenta
            </span>
          </md-card-header>
          <md-card-content>  
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p> 
              <p align="justify">
                Modalidad de envío del Estado de Cuenta *
              </p>

              <div>
                <md-checkbox v-model="form.modalidadenvio" value="Envío a correo electrónico">Envío a correo electrónico</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('modalidadenvio')">
                <span class="md-error" v-if="!$v.form.modalidadenvio.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>          

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>  

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item20',
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item20
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        modalidadenvio: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item20
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('setSaveForm', {id:"20", form: this.form, index: "21"}); 
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
